import React from "react";

export default function ReminderExtendedSettings({
  expanded,
  onToggle,
  sleepModeAfterReminder = true,
  onSleepModeAfterReminderChange,
}) {
  return (
    <div className="pt-1">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={expanded}
        className="text-xs font-medium text-[#245a96] underline underline-offset-2 hover:text-[#1a4674]"
      >
        erweiterte Einstellungen{" "}
        <span className="inline-block">{expanded ? "▴" : "▾"}</span>
      </button>

      {expanded && (
        <div className="mt-2 rounded-lg border border-blue-100 bg-white/70 p-2">
          <div className="rounded-md bg-white p-2">
            <div className="text-sm font-semibold text-[#0b1b2d]">
              Schlafmodus nach Abspielen der Erinnerung
            </div>
            <div className="mt-0.5 text-xs leading-tight text-gray-600">
              Wenn aktiviert, geht das Gerät nach dem Abspielen der Erinnerung
              wieder in den Schlafmodus.
            </div>

            <div className="mt-2 inline-flex rounded-md border border-gray-300 bg-white p-0.5">
              <button
                type="button"
                onClick={() => onSleepModeAfterReminderChange?.(true)}
                className={
                  sleepModeAfterReminder
                    ? "rounded px-3 py-1 text-xs font-semibold bg-[#76B3FF] text-white"
                    : "rounded px-3 py-1 text-xs text-gray-700 hover:bg-gray-100"
                }
              >
                Ja
              </button>
              <button
                type="button"
                onClick={() => onSleepModeAfterReminderChange?.(false)}
                className={
                  !sleepModeAfterReminder
                    ? "rounded px-3 py-1 text-xs font-semibold bg-[#76B3FF] text-white"
                    : "rounded px-3 py-1 text-xs text-gray-700 hover:bg-gray-100"
                }
              >
                Nein
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
